import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";

export interface HttpResponse<T> {
  status: number;
  result: T;
}

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private _http: HttpClient) {}

  public post<T>(url: string, body: any, options: any = {}): Observable<T> {
    return this._http.post<HttpResponse<T>>(url, body, options)
      .pipe(
        map((response: any) => response.result)
      );
  }

  public get<T>(url: string, options: any = {}): Observable<T> {
    return this._http.get<HttpResponse<T>>(url, options)
      .pipe(
        map((response: any) => response)
      );
  }
}
